export default class {

    Branches = [];

    IsShowAll = true;

    IsUpdateSorting = false;

    mapFromDto(branchesDto) {

        this.Branches = branchesDto.map(e => new Branch().mapFromDto(e));
        return this;
    }

    mapToDto() {
        let result = this.Branches.map(e => e.mapToDto());
        return JSON.parse(JSON.stringify(result));
    }

    toogleShowAll() {
        this.IsShowAll = !this.IsShowAll;
        this.Branches.forEach(e => e.IsShow = this.IsShowAll);
    }

    setIsUpdateSorting() {
        this.IsUpdateSorting = true;
    }
}

class Branch {

    Id = null;

    Location = null;

    Name = null;

    Regions = [];

    IsShow = true;

    mapFromDto(branchDto) {
        if(!branchDto)
            return this;

        this.Id = branchDto.Id;
        this.Location = branchDto.Location;
        this.Name = branchDto.Name;
        this.Regions = branchDto.Regions;

        return this;
    }

    mapToDto() {
        let result = {

            Id: this.Id,
            Location: this.Location,
            Name: this.Name,
            Regions: this.Regions
        }

        return result;
    }

    toogleShow() {
        this.IsShow = !this.IsShow;
    }
}